import Rmodal from "../../../../components/Rmodal";

import { Alert, Box, Button, FormControl, InputLabel, Paper, TextField, Typography } from "@mui/material";
import { CloseOutlined, SendOutlined } from "@mui/icons-material";

/**
 * RecoveryModal - Component that renders a modal to request the recovery password
 * @component
 */
const RecoveryModal = ({ onClose, onSend, loading, isVisible, handleChange, toast, fieldValue }: propTypes) => {
    return (
        <Rmodal open={isVisible && !loading} toast={toast}>
            <Paper className="tw-flex tw-w-[calc(100vw-24px)] tw-max-w-xl tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-none dark:tw-bg-slate-900" elevation={0} sx={style}>
                <Box className="tw-w-full tw-p-5 sm:tw-p-6">
                    <Typography className="!tw-mb-3 !tw-font-prometo !tw-text-xl !tw-font-bold !tw-text-gtr-teal-dark">
                        Recuperar senha
                    </Typography>
                    <Alert
                        className="!tw-rounded-xl !tw-border-0 !tw-bg-sky-50"
                        severity="info"
                    >
                        {"Insira suas informações para enviarmos a redefinição de senha."}
                    </Alert>
                </Box>
                <Box className="tw-w-full tw-px-5 tw-pb-6 sm:tw-px-6">
                        <FormControl
                            className="form-group tw-w-full"
                            style={{ display: "flex", width: "100%" }}
                        >
                            <InputLabel id="multiple-mail-label" shrink>
                                E-mail
                            </InputLabel>
                            <TextField
                                name="sendEmail"
                                type="email"
                                InputProps={{ label: "E-mail", notched: true }}
                                placeholder="Digite o e-mail"
                                className="form-control"
                                fullWidth
                                autoComplete="off"
                                value={fieldValue}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                    handleChange(event.target.name, event.target.value)
                                }
                                sx={{
                                    "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#fff" },
                                    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#006C77" },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#00B700" },
                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#00B700", borderWidth: 2 },
                                }}
                            />
                        </FormControl>
                </Box>
                <Box className="tw-w-full tw-border-t tw-border-slate-100 tw-bg-slate-50 tw-p-4 dark:tw-border-slate-700 dark:tw-bg-slate-900">
                    <Box
                        className="tw-flex tw-flex-col-reverse tw-justify-end tw-gap-2 sm:tw-flex-row"
                    >
                        <Button
                            type="button"
                            style={{ fontFamily: "Prometo", color: "#ffff" }}
                            onClick={() => {
                                onClose();
                            }}
                            className="btn btn-primary btn-block login-button-close tw-self-end"
                        >
                            <CloseOutlined style={{ marginRight: 5 }} />
                            <Typography
                                className="forgot-password"
                                style={{ fontFamily: "Prometo", fontSize: "16px", color: "#ffff" }}
                            >
                                Fechar
                            </Typography>
                        </Button>
                        
                        <Button
                            type="button"
                            style={{ fontFamily: "Prometo", color: "#ffff" }}
                            onClick={() => {
                                onSend();
                            }}
                            className="btn btn-primary btn-block login-button tw-self-end"
                        >
                            <SendOutlined style={{ marginRight: 5 }} />
                            <Typography
                                className="forgot-password"
                                style={{ fontFamily: "Prometo", fontSize: "16px", color: "#ffff" }}
                            >Enviar</Typography>
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Rmodal>
    );
};

type propTypes = {
    isVisible: boolean;
    onClose: () => void;
    children?: JSX.Element;
    toast?: JSX.Element;
    onSend: () => void;
    loading: boolean;
    handleChange: (...args: any) => void;
    fieldValue: string;
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "calc(100vw - 24px)",
    maxWidth: 576,
    maxHeight: "calc(100dvh - 24px)",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    bgcolor: "#ffffff",
    border: "none",
    borderRadius: 4,
    color: "black",
    lineBreak: "anywhere",
    padding: 0,
};

export default RecoveryModal;
